import { copyText } from "../lib/format.ts";
import { phraseTitle } from "@shared/phrases.ts";
import type { ThaiPhrase } from "@shared/schema.ts";
import { Link } from "react-router";
import type { ReactNode } from "react";
import { SwipeDeck } from "./SwipeDeck.tsx";

export function PhraseDeck({
  phrases,
  index,
  onIndexChange,
  dock,
}: {
  phrases: ThaiPhrase[];
  index: number;
  onIndexChange: (index: number) => void;
  dock?: ReactNode;
}) {
  if (phrases.length === 0) return <p className="muted">No phrases yet.</p>;

  return (
    <SwipeDeck label="Useful Thai" index={index} onIndexChange={onIndexChange} dock={dock}>
      {phrases.map((phrase) => {
        const unreviewed = !phrase.translationReviewed;
        return (
          <section key={phrase.id} className="show-card phrase-card" aria-live="polite">
            <p className="kicker">Useful Thai</p>
            <h2 className="serif show-card-title">{phraseTitle(phrase)}</h2>
            {unreviewed ? <p className="banner">Not owner-reviewed yet.</p> : null}
            <p className="phrase-thai" lang="th">{phrase.thai}</p>
            <p className="phrase-english">{phrase.english}</p>
            <p className="phrase-roman">{phrase.romanization}</p>
            <div className="row-actions">
              <button className="btn-secondary" type="button" onClick={() => void copyText(phrase.thai)}>
                Copy Thai
              </button>
              <Link className="btn" to={`/show/${phrase.id}`} viewTransition>Show this card</Link>
            </div>
          </section>
        );
      })}
    </SwipeDeck>
  );
}
